import { type FC } from 'react';
import classNames from 'classnames';
import { SvgComponentProps } from '../../../components/Icons/types';
import classes from '../styles/index.module.css';
import { useStyleContextState } from '../../styleContext';
import { ToolNavigationActiveLine } from './ToolNavigationActiveLine';
import RouteLink from '../../../components/RouteLink';

type ToolNavigationLinkPrimaryProps = {
	url: string;
	title: string;
	isActive?: boolean;
	dataTestId?: string;
	icon?: FC<SvgComponentProps>;
	onClick?: () => void;
	hasCollapseButton?: boolean;
	target?: '_blank' | '_self';
	forceUseLink?: boolean;
};

export const ToolNavigationLinkPrimary: FC<ToolNavigationLinkPrimaryProps> = ({
	isActive,
	url,
	title,
	dataTestId,
	icon: ToolNavigationPrimaryLinkIcon,
	onClick,
	hasCollapseButton,
	target,
	forceUseLink,
}) => {
	const { mainColor } = useStyleContextState();

	const navigationLinkClasses = classNames(classes.toolNavigationLink, {
		[classes.toolNavigationLink_hasCollapseButton]: hasCollapseButton,
	});
	const style = isActive
		? {
				color: mainColor,
				borderColor: mainColor,
				fill: mainColor,
		  }
		: undefined;

	return (
		<RouteLink
			className={navigationLinkClasses}
			href={url}
			hasColor={false}
			onClick={onClick}
			dataTestId={dataTestId}
			style={style}
			target={target}
			useDirty
			forceUseLink={forceUseLink}
		>
			{isActive && <ToolNavigationActiveLine />}
			<span className={classes.toolNavigationLink__leftColumn}>
				{ToolNavigationPrimaryLinkIcon && (
					<ToolNavigationPrimaryLinkIcon
						style={style}
						fill='currentColor'
					/>
				)}
			</span>
			<span className={classes.toolNavigationLink__rightColumn}>{title}</span>
		</RouteLink>
	);
};
